import React from 'react';
import PropTypes from 'prop-types';

AtomText.propTypes = {
  text: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.shape({
      content: PropTypes.string.isRequired,
      style: PropTypes.object
    }))
  ]),
  className: PropTypes.string,
  onClick: PropTypes.func,
  style: PropTypes.object,
  type: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'h7', 'h8']),
  filter: PropTypes.bool,
  filterText: PropTypes.string,
  loader: PropTypes.bool
};

AtomText.defaultProps = {
  text: null,
  className: null,
  onClick: null,
  style: null,
  type: 'h1',
  filter: false,
  filterText: '',
  loader: true
};

function AtomText(props) {
  const { type, text, className, onClick, style, filter, filterText } = props;
  const headingLevel = `text-h${type.replace('h', '')}`;

  let finalClassName = `${headingLevel}`;
  if (className) {
    finalClassName += ` ${className}`;
  }

  const renderTextContent = () => {
    if (filter) {
      const { firstText, lastText } = getFilteredText(text, filterText);
      return (
        <>
          <span style={{ fontWeight: '600', marginRight: '-2px' }}>{firstText}</span>{' '}
          {lastText}
        </>
      );
    }
    if (Array.isArray(text)) {
      return text.map((segment, index) => (
        <span key={index} style={segment.style}>{segment.content}</span>
      ));
    }
    return text;
  };

  const getFilteredText = (text, filterText) => {
    if (!text || !filterText) return { firstText: text || '', lastText: '' };

    const index = text.toUpperCase().indexOf(filterText.toUpperCase());
    if (index === -1) return { firstText: text, lastText: '' };

    const firstText = text.slice(index, index + filterText.length);
    const lastText = text.slice(index + filterText.length);
    return { firstText, lastText };
  };

  return (
    <p className={finalClassName} style={style} onClick={onClick}>
      {renderTextContent()}
    </p>
  );
}

export default AtomText;
